import * as React from 'react';
import { useRouter } from 'next/router';

import { useCompanyQuerystringParams } from './useCompanyQuerystringParams';
import { CompanyIdProvider } from './CompanyIdProvider';

export type CompanyIdFromRouteProviderProps = {
  children: React.ReactNode;
};

export const CompanyIdFromRouteProvider = ({
  children,
}: CompanyIdFromRouteProviderProps) => {
  const { companyId } = useCompanyQuerystringParams();
  const router = useRouter();
  const isMateOrLandingPageRoute = ['/', '/mate', '/mate-verify'].includes(
    router.pathname
  );

  return (
    (isMateOrLandingPageRoute && <>{children}</>) || (
      <CompanyIdProvider companyId={companyId}>{children}</CompanyIdProvider>
    )
  );
};
